import React, { useState, useEffect  } from 'react'
import {
  Row,
  Col,
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useSelector } from "react-redux";
// import { useDrag, useDrop } from 'react-dnd'

// EvalComparisonWordSeikai
const EvalComparisonWordSeikai = (props) => {

  let [pairStatus, setPairStatus] = useState('');
  let [bgColor, setBgColor] = useState("#20A2B8")
  let [wordType, setWordType] = useState("default")

  // // componentDidMount
  // useEffect(() => {
  //
  //   if ( props.item && props.item.wordType ) {
  //     setWordType(props.item.wordType)
  //   }
  //
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [props.item]);

  // const [{ isDragging }, drag] = useDrag({
  //   item: {
  //     type: 'seikai',
  //     item: props.item,
  //   },
  //   collect: (monitor) => ({
  //     isDragging: !!monitor.isDragging()
  //   })
  // })
  // const [{ isOver }, drop] = useDrop({
  //   accept: 'seikai',
  //   drop: (aaa) => _swapWords(aaa.item, aaa.type),
  //   collect: monitor => ({
  //     isOver: !!monitor.isOver(),
  //   }),
  // })

  // let _swapWords = (fromItem, fromwordType) => {
  //   props.swapSeikai(fromItem, props.item)
  // }

  // // toggle pair status
  // let _toggleStatus = () => {
  //
  //   if ( wordType === "default" ) {
  //     setWordType("important")
  //     props.updateWordType(props.item, "important")
  //   } else {
  //     setWordType("default")
  //     props.updateWordType(props.item, "default")
  //   }
  // }

  // componentDidMount
  useEffect(() => {

    if (props.item && props.item.status) {
      setPairStatus(props.item.status)
    }

    if (props.item.status === "ok") {
      setBgColor("#20A2B8")
    } else {
      setBgColor("green")
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.item.prediction]);

  return (
    <span>
      <span
        style={{
        backgroundColor: bgColor,
        color: 'white',
        borderRadius: 4,
        padding: 6,
        margin: 6,
        marginLeft: 8,
        marginRight: 8,
      }}>
        {props.item.seikai}
      </span>
    </span>
  )
}

export default EvalComparisonWordSeikai
